import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  public get title() {
    return 'AG Contact Manager';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
